export const navLinks = [
  {label: 'Services', to: '/services'},
  {label: 'Paver Styles', to: '/materials'},
  {label: 'Gallery', to: '/gallery'},
  {label: 'About', to: '/about'}
];

export const services = [
  {
    slug: 'driveways',
    title: 'Driveways',
    tag: 'The first impression',
    text: 'A paver driveway sets the tone for the whole home. We build durable,beautifully patterned approaches on a properly engineered base.',
    points: ['Engineered base preparation', 'Custom borders and inlays', 'Designed for drainage'],
    image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&w=1400&q=85'
  },
  {
    slug: 'patios',
    title: 'Patios & Outdoor Living',
    tag: 'Room to gather',
    text: 'Turn your yard into an extension of your home with patios,seating areas and outdoor living spaces made for long evenings.',
    points: ['Entertaining layouts', 'Seamless transitions to the home', 'Material pairing guidance'],
    image: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=1400&q=85'
  },
  {
    slug: 'pool-decks',
    title: 'Pool Decks',
    tag: 'Resort at home',
    text: 'Cool,comfortable,slip-conscious surfaces around the water,chosen and laid to make the pool the centerpiece of the yard.',
    points: ['Cooler-underfoot materials', 'Clean edge detailing', 'Coordinated with coping'],
    image: 'https://images.unsplash.com/photo-1572331165267-854da2b10ccc?auto=format&fit=crop&w=1400&q=85'
  },
  {
    slug: 'walkways',
    title: 'Walkways & Entries',
    tag: 'Details that connect',
    text: 'From the curb to the front door,walkways and entry steps that guide guests and finish the property with intention.',
    points: ['Curved and straight layouts', 'Step and landing detail', 'Pattern matched to the driveway'],
    image: 'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?auto=format&fit=crop&w=1400&q=85'
  }
];

export const materials = [
  {
    name: 'Old Chicago',
    mood: 'Reclaimed character',
    text: 'Warm,timeworn brick with the soul of a historic street. Rich variation makes every surface feel like it has always belonged.',
    best: 'Driveways,patios,walkways',
    color: '#a65d45',
    grout: '#5a2f26'
  },
  {
    name: 'Classic Brick',
    mood: 'Timeless and crisp',
    text: 'A clean,enduring red-brick look that suits traditional and contemporary homes alike.',
    best: 'Driveways,entries,paths',
    color: '#9a4a37',
    grout: '#4a241c'
  },
  {
    name: 'Travertine',
    mood: 'Sun-washed elegance',
    text: 'Naturally cool,softly textured stone with a calm,resort-like warmth. A favorite around pools.',
    best: 'Pool decks,patios,courtyards',
    color: '#c4a77d',
    grout: '#7d6a4f'
  },
  {
    name: 'Marble',
    mood: 'Quietly extraordinary',
    text: 'Luminous natural variation for outdoor spaces with a truly elevated point of view.',
    best: 'Pool decks,patios,accents',
    color: '#c9cac2',
    grout: '#8a8c86'
  }
];

export const projects = [
  {
    title: 'A grand arrival',
    category: 'Driveways',
    material: 'Classic Brick',
    image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&w=1600&q=85',
    text: 'An entrance that sets the tone before you open the door.'
  },
  {
    title: 'The long afternoon',
    category: 'Patios',
    material: 'Old Chicago',
    image: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=1400&q=85',
    text: 'A place to gather,unwind and enjoy being outside.'
  },
  {
    title: 'Private escape',
    category: 'Pool Decks',
    material: 'Travertine',
    image: 'https://images.unsplash.com/photo-1572331165267-854da2b10ccc?auto=format&fit=crop&w=1400&q=85',
    text: 'The feeling of getting away without leaving home.'
  },
  {
    title: 'A path worth taking',
    category: 'Walkways',
    material: 'Classic Brick',
    image: 'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?auto=format&fit=crop&w=1400&q=85',
    text: 'Small details that connect the whole property.'
  },
  {
    title: 'Made for moments',
    category: 'Walkways',
    material: 'Classic Brick',
    image: 'https://images.unsplash.com/photo-1558904541-efa843a96f01?auto=format&fit=crop&w=1400&q=85',
    text: 'A garden path that brings paving and planting together.'
  },
  {
    title: 'Summer starts here',
    category: 'Pool Decks',
    material: 'Marble',
    image: 'https://images.unsplash.com/photo-1576013551627-0cc20b96c2a7?auto=format&fit=crop&w=1400&q=85',
    text: 'A little everyday luxury right outside your door.'
  }
];

export const process = [
  {n: '01', title: 'Consult & measure', text: 'We walk the property,listen to how you live and measure every detail.'},
  {n: '02', title: 'Design & select', text: 'Choose your material,color and pattern with samples in hand.'},
  {n: '03', title: 'Precision install', text: 'Excavation,base,edge restraint and laying,done right the first time.'},
  {n: '04', title: 'Final walkthrough', text: 'We inspect the finished work with you and share care guidance.'}
];

export const faqs = [
  {q: 'How long do brick pavers last?', a: 'With a properly built base and basic care,pavers are one of the longest-lasting surfaces you can choose for outdoor spaces.'},
  {q: 'Why does the base matter so much?', a: 'Most paver problems start below the surface. Proper excavation,compacted base and drainage are what keep a surface flat for years.'},
  {q: 'Can I see samples before deciding?', a: 'Yes. Colors on a screen are only a guide,so we recommend reviewing physical samples in your own light before final selection.'},
  {q: 'Can pavers be repaired?', a: 'Yes. Individual pavers can be lifted and reset,which is one of the practical advantages over poured surfaces.'},
  {q: 'What should I prepare before a consultation?', a: 'Rough dimensions,a few photos of inspiration and an idea of how you use the space are plenty to start.'}
];
